import Snackbar, { SnackbarProps } from "@mui/material/Snackbar";
import { useMobile } from "../hooks/useMobile";

export type EmtSnackbarProps = SnackbarProps & { nonce?: string };

export function EmtSnackbar(props: EmtSnackbarProps) {
  const { ...rest } = props;
  const [isMobile] = useMobile();
  return (
    <Snackbar
      {...rest}
      anchorOrigin={{
        vertical: isMobile ? "bottom" : "top",
        horizontal: isMobile ? "center" : "right",
      }}
      sx={{
        top: isMobile ? "auto" : "100px !important",
        bottom: isMobile ? "100px !important" : "auto",
      }}
    />
  );
}
